import { apiClient } from './client'

export interface SyslogConfig {
  id: string
  host: string
  port: number
  protocol: string
  log_level: string
  facility: string
  app_name: string
  is_enabled: boolean
  created_at: string | null
  updated_at: string | null
  updated_by: string | null
}

export interface SyslogConfigCreate {
  host: string
  port: number
  protocol: string
  log_level: string
  facility: string
  app_name: string
  is_enabled: boolean
}

export interface SyslogTestRequest {
  host: string
  port: number
  protocol: string
}

export interface SyslogTestResponse {
  success: boolean
  message: string
}

export const syslogApi = {
  async getConfig(): Promise<SyslogConfig> {
    const response = await apiClient.get('/syslog/config')
    return response.data
  },

  async saveConfig(data: SyslogConfigCreate): Promise<SyslogConfig> {
    const response = await apiClient.post('/syslog/config', data)
    return response.data
  },

  async deleteConfig(): Promise<void> {
    await apiClient.delete('/syslog/config')
  },

  async toggleConfig(): Promise<SyslogConfig> {
    const response = await apiClient.post('/syslog/config/toggle')
    return response.data
  },

  async testConnection(data: SyslogTestRequest): Promise<SyslogTestResponse> {
    const response = await apiClient.post('/syslog/test', data)
    return response.data
  },
}
